export const MODULE_NAME = 'one-identity-login';

export const STEP_ENTER_USERNAME = 1;
export const STEP_ENTER_PASSWORD = 2;

export const AUTH_READY_TIMEOUT = 2e3; // wait 2 seconds for inAuth

export const LOGIN_RESPONSE_SUCCESS = 'SUCCESS';
export const LOGIN_RESPONSE_LGON001 = 'LGON001'; // invalid userid/password
export const LOGIN_RESPONSE_LGON003 = 'LGON003'; // almost locked (2 incorrect attempts)
export const LOGIN_RESPONSE_LGON004 = 'LGON004'; // revoked on 3rd login attempt
export const LOGIN_RESPONSE_LGON005 = 'LGON005'; // previously locked
export const LOGIN_RESPONSE_LGON006 = 'LGON006'; // already logged in (Mexico only)
export const LOGIN_RESPONSE_LGON007 = 'LGON007'; // force reset password, use legacy login
export const LOGIN_RESPONSE_LGON008 = 'LGON008'; // Reauth - redirect to redirectUrl
export const LOGIN_RESPONSE_LGON009 = 'LGON009'; // Reauth - AuthN+
export const LOGIN_RESPONSE_LGON010 = 'LGON010'; // System error
export const LOGIN_RESPONSE_LGON011 = 'LGON011'; // Rockstar (API)
export const LOGIN_RESPONSE_LGON012 = 'LGON012'; // Unknown, treat as System error
export const LOGIN_RESPONSE_LGON013 = 'LGON013'; // Multi Step Authentication
export const LOGIN_RESPONSE_LGON014 = 'LGON014'; // Unknown, treat as System error
export const LOGIN_RESPONSE_LGON015 = 'LGON015'; // force change Password - OneAmex
export const LOGIN_RESPONSE_LGON016 = 'LGON016'; // Redirect to market specific login page (Mexico)
export const LOGIN_RESPONSE_LGON017 = 'LGON017'; // Rockstar (Mitigator)
export const LOGIN_RESPONSE_LGON018 = 'LGON018'; // Rockstar captcha modal
export const LOGIN_RESPONSE_LGON020 = 'LGON020'; // Government ID cannot be used as a username

// logging
export const LOGIN_CLICK = 'Login click';
export const LOGIN_INVOCATION = 'Login API invoked';
export const LOGIN_RESPONSE_RECEIVED = 'Login response received';
export const ROUTE_TO_DESTINATION = 'Routing to destination URL';
export const LOGIN_EVENT_FAILURE = 'Login failure';
export const EVENT_ARRAY_LOG = 'Login and routing event array';
export const EVENT_ARRAY_FAILURE_LOG = 'Login failure event array';

export const CONTENT_TYPE = 'Content-Type';
export const CONTENT_TYPE_JSON = 'application/json; charset=UTF-8';
export const PARAM_CORRELATION_ID = 'one-data-correlation-id';

export const MESSAGE_POSITIVE = 'success';
export const MESSAGE_NEUTRAL = 'neutral';
export const MESSAGE_WARNING = 'warning';

export const TYPE_MUTLIPAGE = 'multipage';

export const MIGRATION_TYPE_MERCHANT = 'merchant';
export const MIGRATION_TYPE_ATWORK = 'atWork';

export const AEXP_CROSS_BORDER_PAYMENTS = 'AEXP_CROSS_BORDER_PAYMENTS';

export const SUPPORTED_LOCALES = [
  'de-at',
  'de-ch',
  'de-de',
  'en-au',
  'en-ca',
  'en-gb',
  'en-hk',
  'en-in',
  'en-la',
  'en-nz',
  'en-sg',
  'en-th',
  'en-us',
  'en-xa',
  'en-xb',
  'es-ar',
  'es-es',
  'es-mx',
  'fi-fi',
  'fr-be',
  'fr-ca',
  'fr-ch',
  'fr-fr',
  'it-it',
  'ja-jp',
  'nb-no',
  'nl-be',
  'nl-nl',
  'sv-se',
  'th-th',
  'zh-hk',
  'zh-tw',
];
